import { InputLayout, InputLayoutProps } from '../InputLayout';
import { useInput } from '../hooks/useInput';

import { MaskedControl } from './MaskedControl';

export const InputMask = {
    Date: '00.00.0000',
    phone: '+0 (000) 000-00-00',
    SNILS: '000-000-000 00',
    INN: '000000000000',
    KPP: '000000000',
    RegistrationNumber: '0000000000000',
    Time: '00:00',
    Duration: '0[0][0][0][0] мин',
    DurationHours: '0[0][0] ч',
};

export const DefaultMaskValue = '__/__';

export interface MaskedInputProps
    extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'onChange'>, InputLayoutProps {
    value: string | number;
    mask: string;
    dataTest?: string;
    alwaysShowMask?: boolean;
    formatChars?: Record<string, string | RegExp>;
    forcePlaceholder?: boolean;
    onChangeValue?(value: string, name?: string): void;
    onBlur?(event: React.FocusEvent<HTMLInputElement>): void;
    onFocus?(event: React.FocusEvent<HTMLInputElement>): void;
}

export function MaskedInput({
    value,
    mask,
    alwaysShowMask,
    formatChars,
    leftTitle,
    title,
    titleHint,
    theme,
    modifiers,
    notValidText,
    iconLinkProps,
    isValid,
    isRequired,
    isImportant,
    showValidStatus,
    dataTest,
    forcePlaceholder,
    placeholder,
    onChangeValue,
    onBlur,
    onFocus,
    ...props
}: MaskedInputProps) {
    const { isOnFocus, inputValue, setInputElement, commitValue, handleFocus, handleBlur } = useInput({
        value,
        isControlled: Boolean(onChangeValue),
        name: props.name,
        autoFocus: props.autoFocus,
        onBlur,
        onFocus,
    });

    const titleText = isRequired ? `${title} *` : title;

    const handleChangeValue = (newValue: string): void => {
        if (onChangeValue) {
            onChangeValue(newValue, props.name);
        }

        commitValue(newValue);
    };

    return (
        <InputLayout
            isOnFocus={isOnFocus}
            isEmpty={!inputValue || inputValue === ''}
            disabled={props.disabled}
            leftTitle={leftTitle}
            title={title}
            titleHint={titleHint}
            theme={theme}
            modifiers={modifiers}
            notValidText={notValidText}
            iconLinkProps={iconLinkProps}
            isValid={isValid}
            isRequired={isRequired}
            isImportant={isImportant}
            showValidStatus={showValidStatus}
        >
            <MaskedControl
                {...props}
                value={inputValue}
                mask={mask}
                alwaysShowMask={alwaysShowMask}
                formatChars={formatChars}
                dataTest={dataTest}
                inputRef={setInputElement}
                placeholder={title ? (forcePlaceholder ? placeholder : undefined) : placeholder || titleText}
                onChangeValue={handleChangeValue}
                onBlur={handleBlur}
                onFocus={handleFocus}
            />
        </InputLayout>
    );
}
